import React from 'react';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import type { Database } from '@/integrations/supabase/types';

type PropFirm = Database['public']['Tables']['prop_firms']['Row'];

interface AccountSizeSelectorProps {
  selectedSize: string;
  onSizeChange: (value: string) => void;
  className?: string;
}

const ACCOUNT_SIZES = [
  { id: '25k', size_value: '$25,000' },
  { id: '50k', size_value: '$50,000' },
  { id: '75k', size_value: '$75,000' },
  { id: '100k', size_value: '$100,000' },
  { id: '150k', size_value: '$150,000' },
  { id: '200k', size_value: '$200,000' },
  { id: '250k', size_value: '$250,000' },
  { id: '300k', size_value: '$300,000' },
];

export default function AccountSizeSelector({ selectedSize, onSizeChange, className }: AccountSizeSelectorProps) {
  const handleChange = (value: string) => {
    if (typeof window.gtag === 'function') {
      window.gtag('event', 'filter_change', {
        filter_type: 'account_size',
        value,
      });
    }
    onSizeChange(value);
  };

  return (
    <div className="flex items-center gap-2">
      <label htmlFor="account-size" className="font-medium text-gray-700 dark:text-gray-300">
        Account Size:
      </label>
      <Select value={selectedSize} onValueChange={handleChange}>
        <SelectTrigger className={className}>
          <SelectValue placeholder="Select account size" />
        </SelectTrigger>
        <SelectContent>
          {ACCOUNT_SIZES.map((size) => (
            <SelectItem key={size.id} value={size.id}>
              {size.size_value}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
}
